import { useNavigate, useRouteLoaderData } from '@remix-run/react';
import type { TNavbarDropdownElementItem } from '@shared/dream-components';
import { NavbarMenuDropdownItemV2 as NavbarMenuDropdownItemElement } from '@shared/dream-components';
import type { ReactNode } from 'react';

import { getNodeActionAndVisibility } from '../utils/getNodeActionAndVisibility';

import { usePageContext } from '~/context/usePageContext';
import type { RootLoaderData } from '~/root';

interface Props {
  node: TNavbarDropdownElementItem;
  children: ReactNode | ReactNode[];
  screen: 'desktop' | 'mobile';
}

const NavbarMenuDropdownItem = ({ node, children, screen }: Props) => {
  const navigate = useNavigate();
  const { subscription } = usePageContext();
  const isPremiumUser = subscription?.tier === 'premium';
  const { isLoggedIn } = useRouteLoaderData<RootLoaderData>('root') || {};

  const { handleClientSideNavigation } = getNodeActionAndVisibility(
    node,
    subscription,
    navigate,
    Boolean(isLoggedIn),
    isPremiumUser,
  );

  return (
    <NavbarMenuDropdownItemElement element={node} screen={screen} onClick={handleClientSideNavigation}>
      {children}
    </NavbarMenuDropdownItemElement>
  );
};

export default NavbarMenuDropdownItem;
